<template>
<div>
  <div class="flex">
    <div class="mb-4 w-1/4">
      <vs-button color="primary" type="filled" @click="showCreate"
                 icon="control_point" class="mt-4">
        {{ $t('message.partners.formAdd') }}
      </vs-button>
    </div>
  </div>
  <div>
    <vs-input type="text" v-model="findText" />
  </div>
  <vs-table
    stripe :data="findPartners" pagination :maxItems="10"
    class="w-full mt-4" @selected="setSelected"
    :noDataText="$t('message.partners.noDataText')">
    <template slot="thead">
      <vs-th>{{ $t('message.partners.tin') }}</vs-th>
      <vs-th>{{ $t('message.partners.name') }}</vs-th>
      <vs-th>{{ $t('message.partners.accountMain') }}</vs-th>
      <vs-th></vs-th>
    </template>
    <template :slot-scope="{findPartners}">
      <template v-for="row in findPartners">
        <vs-tr :key="row.id" :data="row.template_tp_id">
          <vs-td>{{ row.tp_tin }}</vs-td>
          <vs-td>{{ row.tp_name }}</vs-td>
          <vs-td>{{ row.account_number }}</vs-td>
          <vs-td>
            <vs-button color="primary" class="inline-block mr-2" @click="editClick(row)"
                       type="border" icon="edit" />
            <vs-button color="primary" class="inline-block mr-2" type="border" icon="content_copy" v-if="false" />
            <vs-button color="primary" class="inline-block mr-2" type="border" icon="get_app" v-if="false" />
            <vs-button color="primary" class="inline-block" type="border" icon="print" v-if="false" />
            <vs-button color="primary" class="inline-block" type="border" icon="delete" @click.stop.prevent="deleteClick(row)" />
          </vs-td>
        </vs-tr>
        <template v-if="row.template_tp_id === selectedId && getPartnerAccounts">
          <vs-tr :key="'expand' + row.id">
            <vs-td colspan="4">
              <div v-for="item in getPartnerAccounts" :key="item.id">
                <div class="flex">
                  <div class="w-1/3">{{ $t('message.partners.account') }}</div>
                  <div class="w-2/3">{{ item.account_number }}</div>
                </div>
                <div class="flex">
                  <div class="w-1/3">{{ $t('message.partners.bank') }}</div>
                  <div class="w-2/3">{{ item.bank_name }}</div>
                </div>
                <div class="flex">
                  <div class="w-1/3">{{ $t('message.partners.bik') }}</div>
                  <div class="w-2/3">{{ item.bank_bik }}</div>
                </div>
                <vs-divider />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </template>
    </template>
  </vs-table>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'InternalList',
  data: () => ({
    selectedId: false,
    findText: ''
  }),
  methods: {
    ...mapActions('partners', ['fetchPartners', 'fetchPartnerAccounts']),
    showCreate () {
      this.$emit('show-form')
    },
    deleteClick (row) {
      this.$emit('delete-template', row)
    },
    setSelected (val) {
      if (this.selectedId === val) {
        this.selectedId = false
      } else {
        this.selectedId = val
        this.fetchPartnerAccounts(val)
      }
      console.log(this.selectedId, val)
    },
    editClick (row) {
      this.$emit('edit-template', row)
    }
  },
  computed: {
    ...mapGetters('partners', ['getPartners', 'getPartnerAccounts']),
    findPartners () {
      if (!this.getPartners) return []
      if (!this.getPartners.filter) return []
      return this.getPartners.filter((item) => {
        if (this.findText.length === 0) return true
        return item.tin.indexOf(this.findText) !== -1 || item.name.indexOf(this.findText) !== -1
      })
    }
  },
  mounted () {
    this.fetchPartners()
  }
}
</script>

<style scoped>

</style>
